export enum LEARNING {
    // https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=485832546
    MISSION_CENTER = 'LEARNING.MISSION_CENTER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=485826828
     */
    LEARNING = 'ADMIN.NAV.LEARNING',
}
